/**
 * 智慧平板-设备环境管理
 */
import request from '@/utils/request';
// import { getToken } from '@/utils/auth';
// import ENVIRONMENT from '@/utils/environment';

/**
  * 获取列表
  */
export function getEnvDeviceList(options) {
  return request({
    url: `/device/environments`,
    method: 'get',
    params: options
  });
}
/**
  * 创建环境
  */
export function getEnvDeviceAdd(options) {
  return request({
    url: `/device/environments`,
    method: 'post',
    data: options
  });
}/**
  * 删除环境
  */
export function getEnvDeviceDel(environmentId) {
  return request({
    url: `/device/environments/${environmentId}`,
    method: 'DELETE'
  });
}
/**
 * 首页/智慧平板/ 设备入库
 */

/**
  * 获取列表
  */
export function getDeviceRelationsList(options) {
  return request({
    url: `/device/environment/relations`,
    method: 'get',
    params: options
  });
}
/**
  * 创建环境
  */
export function getEnvDeviceRelationsAdd(options) {
  return request({
    url: `/device/environment/relations`,
    method: 'post',
    data: options
  });
}/**
  * 删除环境
  */
export function getEnvDeviceRelationsDel(deviceRelationId) {
  return request({
    url: `/device/environment/relations/${deviceRelationId}`,
    method: 'DELETE'
  });
}

/**
  * 批量导入
  */
export function getEnvDeviceRelationsBatch(options, environmentId) {
  return request({
    url: `/device/environment/relations/batch?environmentId=${environmentId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: options
  });
}
